<script>
import baseList from "@/views/components/base/baseList.vue";
import CampusEditModal from "./CampusEditModal.vue";

export default {
  extends: baseList,
  components: {
    CampusEditModal
  },
  data() {
    return {
      table: {
        mname: "hospitalArea",
        key: "id",
        url: {
          list: "/admin/system/hospitalArea/list",
          del: "/admin/system/hospitalArea/batch/",
        },
        output: false,
      },
      actions: [
        {
          label: "新增院区",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "",
        },
      ],
      filters: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "院区名称",
          key: "areaName",
          align: "center",
        },
        {
          title: "地址",
          key: "areaAddress",
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <div>
                  <Button
                    size="small"
                    onClick={() => this.toedit(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      marginRight: "10px",
                    }}
                  >
                    编辑
                  </Button>
                  <Button
                    size="small"
                    onClick={() => this.delItem(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff"
                    }}
                  >
                    删除
                  </Button>
                </div>
              );
            },
          ],
        },
      ],
    };
  },
  created() { },
  methods: {
    onCancel() {
      this.$Modal.remove();
      this.search();
    },
    toAdd() {
      this.$Modal.success({
        closable: true,
        width: "640px",
        title: "新增院区",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <CampusEditModal
                onOnCancel={() => {
                  this.onCancel();
                }}
                type="add"
              />
            </div>
          );
        },
      });
    },
    toedit(row) {
      this.$Modal.success({
        closable: true,
        width: "640px",
        title: "编辑院区",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <CampusEditModal
                onOnCancel={() => {
                  this.onCancel();
                }}
                actions="edit"
                ids={row.id}
              />
            </div>
          );
        },
      });
    },
    async delItem(row) {
      let d = {};
      let res = await $utils.api.load(
        `/admin/system/hospitalArea/${row.id}`,
        d,
        "DELETE"
      );
      if (res.code == 200) {
        $utils.toast.success("删除成功！");
        setTimeout(() => {
          this.search();
        }, 100);
      }
    },
  },
};
</script>
<style scoped></style>
